export default __webpack_public_path__ + "static/media/Logo.123cf415.svg";